import React from 'react';
import PropTypes from 'prop-types';
import { Impression } from '@nerdwallet/analytics/react/impression';
import { Button, Title, Text, Link } from '@nerdwallet/currency';
import classNames from 'classnames';
import SegmentImpression from '../../segment-impression';
import useAnalytics from '~/client/lib/segment/useAnalytics';
import { HOMEPAGE_SEGMENT_INSTRUMENTATION } from '~/client/lib/analytics-constants';
import NewFeatureTag from '../announcement-banner/new-feature-tag/new-feature-tag';
import styles from './campaign-highlight.module.less';

const CampaignHighlight = ({
  backgroundColor,
  backgroundColorMobile,
  title,
  titleEnd,
  titlePreColor,
  titleEndColor,
  subtitle,
  ctaButtonText,
  ctaLinkUrl,
  visualDesktopBackgroundImageUrl,
  visualMobileBackgroundImageUrl,
  elementImpressionEntityName,
  elementImpressionSectionName,
  trkQueryParam,
}) => {
  const backgroundImageStyleDesktop = {
    backgroundColor: `${backgroundColor}`,
    backgroundImage: `url(${visualDesktopBackgroundImageUrl})`,
    backgroundSize: `cover`,
  };

  const backgroundImageStyleMobile = {
    backgroundColor: `${backgroundColorMobile}`,
    backgroundImage: `url(${visualMobileBackgroundImageUrl})`,
    backgroundSize: 'cover',
    height: 233,
    width: '100%',
  };

  const titlePreStyle = {
    color: `${titlePreColor}`,
  };

  const titleEndStyle = {
    color: `${titleEndColor}`,
  };

  const { trackSegmentTrackEvent } = useAnalytics();
  const handleCampaignLinkClick = () => {
    trackSegmentTrackEvent(
      'Element Interaction',
      HOMEPAGE_SEGMENT_INSTRUMENTATION.campaign
    );
  };

  return (
    <SegmentImpression
      eventName="Element Impression"
      eventProps={{
        entity_name: HOMEPAGE_SEGMENT_INSTRUMENTATION.campaign.sub_location,
        location: HOMEPAGE_SEGMENT_INSTRUMENTATION.campaign.location,
      }}
    >
      <Impression
        entityName={elementImpressionEntityName}
        payload={{ section_name: elementImpressionSectionName }}
      >
        <div className={styles.campaignHighlight}>
          <Link
            href={`${ctaLinkUrl}?trk=${trkQueryParam}`}
            onClick={handleCampaignLinkClick}
            className={styles.campaignHighlightVisualContainerMobile}
          >
            <div style={backgroundImageStyleMobile} />
          </Link>
          <div
            className={styles.campaignHighlightCta}
            style={{ backgroundColor }}
          >
            <NewFeatureTag
              color="#008254"
              classNames={classNames(['campaign-highlight-ribbon'])}
            />
            <Title size="small" className={styles.campaignHighlightCtaTitle}>
              <span
                className={styles.campaignHighlightCtaTitlePre}
                style={titlePreStyle}
              >
                {title}
              </span>
              <span
                className={styles.campaignHighlightCtaTitleEnd}
                style={titleEndStyle}
              >
                {'\u00A0'}
                {'\u00A0'}
                {titleEnd}
              </span>
            </Title>
            <div className={styles.campaignHighlightCtaText}>
              <Text>{subtitle}</Text>
            </div>
            <Button
              href={`${ctaLinkUrl}?trk=${trkQueryParam}`}
              primary
              className={styles.campaignHighlightCtaButton}
              onClick={handleCampaignLinkClick}
            >
              {ctaButtonText}
            </Button>
          </div>
          <Link
            href={`${ctaLinkUrl}?trk=${trkQueryParam}`}
            onClick={handleCampaignLinkClick}
          >
            <div
              className={styles.campaignHighlightVisualContainerDesktop}
              style={backgroundImageStyleDesktop}
            />
          </Link>
        </div>
      </Impression>
    </SegmentImpression>
  );
};

CampaignHighlight.propTypes = {
  backgroundColor: PropTypes.string,
  backgroundColorMobile: PropTypes.string,
  title: PropTypes.string,
  titleEnd: PropTypes.string,
  titlePreColor: PropTypes.string,
  titleEndColor: PropTypes.string,
  subtitle: PropTypes.string,
  ctaButtonText: PropTypes.string,
  ctaLinkUrl: PropTypes.string,
  visualDesktopBackgroundImageUrl: PropTypes.string,
  visualMobileBackgroundImageUrl: PropTypes.string,
  elementImpressionEntityName: PropTypes.string,
  elementImpressionSectionName: PropTypes.string,
  trkQueryParam: PropTypes.string,
};

CampaignHighlight.displayName = 'CampaignHighlight';

export default CampaignHighlight;
